export default __webpack_public_path__ + "static/media/icon_facebook.4dbf4437.svg";